import { getUserbyId } from './getUserById';
import { payrollGetSetup } from './getPayrollSetup';
import { getSalaryDetails } from './getSalaryDetails';
import { getUserByPeopleIds } from './getMultipleUsersById';
import { getArrearApplicabilityDetails } from './getArrearApplicabilityDetails';
import { getPayDetailsBulkPreview } from './getPayDetailsBulkPreview';

export default {
  getUserbyId,
  payrollGetSetup,
  getSalaryDetails,
  getUserByPeopleIds,
  getArrearApplicabilityDetails,
  getPayDetailsBulkPreview,
};
